var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 123,
    viewBox: "0 0 125 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M63.0831 74.3508C72.6206 74.3508 80.3523 66.6192 80.3523 57.0817C80.3523 47.5442 72.6206 39.8125 63.0831 39.8125C53.5456 39.8125 45.814 47.5442 45.814 57.0817C45.814 66.6192 53.5456 74.3508 63.0831 74.3508Z",
    fill: "#6EAEFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8335 55.6445H57.3335C56.5477 55.6445 55.896 54.9929 55.896 54.207C55.896 53.4212 56.5477 52.7695 57.3335 52.7695H68.8335C69.6193 52.7695 70.271 53.4212 70.271 54.207C70.271 54.9929 69.6193 55.6445 68.8335 55.6445Z",
    fill: "#6EAEFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0835 61.3945H57.3335C56.5477 61.3945 55.896 60.7429 55.896 59.957C55.896 59.1712 56.5477 58.5195 57.3335 58.5195H63.0835C63.8693 58.5195 64.521 59.1712 64.521 59.957C64.521 60.7429 63.8693 61.3945 63.0835 61.3945Z",
    fill: "#6EAEFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1474 72.3208C83.5149 71.1517 82.1733 70.5 80.3716 70.5C79.0108 70.5 77.8416 71.0558 77.1516 72.0142C76.4616 72.9725 76.3083 74.2567 76.7299 75.5408C77.5541 78.0325 78.9916 78.5883 79.7774 78.6842C79.8924 78.7033 80.0074 78.7033 80.1416 78.7033C80.9849 78.7033 82.2883 78.3392 83.5533 76.4417C84.5691 74.9658 84.7608 73.49 84.1474 72.3208Z",
    fill: "#6EAEFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_1568_13859)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.6998,
    cy: 61.3013,
    rx: 18.4,
    ry: 17.6333,
    fill: "#6EAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7165 61.3013C80.7165 70.813 72.6657 78.5513 62.6998 78.5513C52.7339 78.5513 44.6831 70.813 44.6831 61.3013C44.6831 51.7896 52.7339 44.0513 62.6998 44.0513C72.6657 44.0513 80.7165 51.7896 80.7165 61.3013Z",
    stroke: "black",
    strokeWidth: 0.766667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1568_13859",
    x: 0.753139,
    y: 0.121304,
    width: 123.893,
    height: 122.359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.7733,
    result: "effect1_foregroundBlur_1568_13859"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.051c0e4606222363ea92de4bd092f14a.svg";
export { ForwardRef as ReactComponent };